// extracted by mini-css-extract-plugin
export default {"container":"UserSection_container__2Hvti"};